export default __webpack_public_path__ + "static/media/intro.02c376ce.mp4";